/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlocked_TextInputs */

const en_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlocked`)
};

const ar_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const de_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigeschaltet`)
};

const es_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueado`)
};

const fr_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloqué`)
};

const it_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccato`)
};

const ja_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンロック済み`)
};

const ko_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`획득함`)
};

const pt_br_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueado`)
};

const ru_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно`)
};

const th_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกแล้ว`)
};

const tr_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilidi açıldı`)
};

const zh_cn_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解锁`)
};

const zh_tw_unlocked_text = /** @type {(inputs: Unlocked_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解鎖`)
};

/**
* | output |
* | --- |
* | "Unlocked" |
*
* @param {Unlocked_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlocked_text = /** @type {((inputs?: Unlocked_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlocked_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlocked_text(inputs)
	if (locale === "ar") return ar_unlocked_text(inputs)
	if (locale === "de") return de_unlocked_text(inputs)
	if (locale === "es") return es_unlocked_text(inputs)
	if (locale === "fr") return fr_unlocked_text(inputs)
	if (locale === "it") return it_unlocked_text(inputs)
	if (locale === "ja") return ja_unlocked_text(inputs)
	if (locale === "ko") return ko_unlocked_text(inputs)
	if (locale === "pt_br") return pt_br_unlocked_text(inputs)
	if (locale === "ru") return ru_unlocked_text(inputs)
	if (locale === "th") return th_unlocked_text(inputs)
	if (locale === "tr") return tr_unlocked_text(inputs)
	if (locale === "zh_cn") return zh_cn_unlocked_text(inputs)
	return zh_tw_unlocked_text(inputs)
});